import React, { useState, useCallback, useEffect, useRef } from 'react';
import api from '../services/api';

const STATUS = [
  { v: 'novo', l: 'Novo', cor: '#1A3A5C', bg: '#E6F1FB' },
  { v: 'contato', l: 'Em contato', cor: '#2471A3', bg: '#D6EAF8' },
  { v: 'simulando', l: 'Simulando', cor: '#6B3FA0', bg: '#F3E8FF' },
  { v: 'aprovado', l: 'Aprovado financ.', cor: '#117A65', bg: '#D1F2EB' },
  { v: 'vem_loja', l: 'Vem na loja', cor: '#E67E22', bg: '#FEF5E7' },
  { v: 'fechado', l: 'Fechado', cor: '#2D7D4F', bg: '#EAF5EE' },
  { v: 'perdido', l: 'Perdido', cor: '#C0392B', bg: '#FDECEA' },
];

const fmt = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  return dt.toLocaleDateString('pt-BR') + ' ' + dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};
const isVencido = (d) => d && new Date(d) <= new Date();
const isHoje = (d) => {
  if (!d) return false;
  const dt = new Date(d); const hoje = new Date();
  return dt.toDateString() === hoje.toDateString();
};
const statusCfg = (v) => STATUS.find(s => s.v === v) || STATUS[0];
const card = { background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '16px 18px' };
const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };

export default function CRM() {
  const [leads, setLeads] = useState([]);
  const [alertas, setAlertas] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [busca, setBusca] = useState('');
  const [modalLead, setModalLead] = useState(false);
  const [modalDetalhe, setModalDetalhe] = useState(null);
  const [historico, setHistorico] = useState([]);
  const [form, setForm] = useState({});
  const [formHist, setFormHist] = useState({ descricao: '', tipo: 'observacao', proximo_followup: '' });
  const [loading, setLoading] = useState(false);
  const alertIntervalRef = useRef(null);

  const tocarAlerta = useCallback(() => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.frequency.value = 880; g.gain.setValueAtTime(0.3, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
      o.start(ctx.currentTime); o.stop(ctx.currentTime + 0.5);
    } catch(e) {}
  }, []);

  const carregarLeads = useCallback(async () => {
    const r = await api.get('/crm/leads', { params: { status: filtroStatus || undefined } });
    setLeads(r.data);
  }, [filtroStatus]);

  const carregarAlertas = useCallback(async () => {
    const r = await api.get('/crm/leads/alertas');
    setAlertas(r.data);
    if (r.data.length > 0) tocarAlerta();
  }, [tocarAlerta]);

  useEffect(() => {
    carregarLeads(); carregarAlertas();
    alertIntervalRef.current = setInterval(carregarAlertas, 60000);
    return () => clearInterval(alertIntervalRef.current);
  }, [carregarLeads, carregarAlertas]);

  useEffect(() => { carregarLeads(); }, [filtroStatus, carregarLeads]);

  const salvarLead = async () => {
    if (!form.nome) { alert('Informe o nome'); return; }
    setLoading(true);
    try {
      if (form.id) await api.put('/crm/leads/' + form.id, form);
      else {
        const r = await api.post('/crm/leads', form);
        if (form.observacao) {
          await api.post('/crm/leads/' + r.data.id + '/historico', { descricao: form.observacao, tipo: 'observacao' });
        }
      }
      setModalLead(false); setForm({});
      carregarLeads(); carregarAlertas();
    } catch(e) { alert('Erro'); }
    finally { setLoading(false); }
  };

  const abrirDetalhe = async (lead) => {
    setModalDetalhe(lead);
    const r = await api.get('/crm/leads/' + lead.id + '/historico');
    setHistorico(r.data);
    setFormHist({ descricao: '', tipo: 'observacao', proximo_followup: '' });
  };

  const salvarHistorico = async () => {
    if (!formHist.descricao) { alert('Informe a observação'); return; }
    try {
      await api.post('/crm/leads/' + modalDetalhe.id + '/historico', formHist);
      if (formHist.status) {
        await api.put('/crm/leads/' + modalDetalhe.id, { ...modalDetalhe, status: formHist.status, proximo_followup: formHist.proximo_followup || modalDetalhe.proximo_followup });
      }
      const r = await api.get('/crm/leads/' + modalDetalhe.id + '/historico');
      setHistorico(r.data);
      setFormHist({ descricao: '', tipo: 'observacao', proximo_followup: '' });
      carregarLeads(); carregarAlertas();
    } catch(e) { alert('Erro'); }
  };

  const abrirWhatsApp = (tel) => {
    const num = tel.replace(/\D/g, '');
    window.open('https://wa.me/55' + num, '_blank');
  };

  const agora = new Date();
  const pendentes = leads.filter(l => {
    if (l.status === 'fechado' || l.status === 'perdido') return false;
    if (busca) { const b = busca.toLowerCase(); return (l.nome||'').toLowerCase().includes(b) || (l.telefone||'').includes(b) || (l.interesse||'').toLowerCase().includes(b); }
    if (filtroStatus) return l.status === filtroStatus;
    if (!l.proximo_followup) return true;
    return new Date(l.proximo_followup) <= agora;
  });
  const agendados = leads.filter(l => {
    if (l.status === 'fechado' || l.status === 'perdido') return false;
    if (busca || filtroStatus) return false;
    return l.proximo_followup && new Date(l.proximo_followup) > agora;
  });
  const encerrados = leads.filter(l => {
    if (busca || filtroStatus) return false;
    return l.status === 'fechado' || l.status === 'perdido';
  });

  const CardLead = ({ l }) => {
    const vencido = isVencido(l.proximo_followup);
    const hoje = isHoje(l.proximo_followup);
    const sc = statusCfg(l.status);
    return (
      <div style={{ ...card, borderLeft: `3px solid ${vencido ? '#C0392B' : hoje ? '#E67E22' : sc.cor}`, cursor: 'pointer' }} onClick={() => abrirDetalhe(l)}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533' }}>{l.nome}</div>
          <span style={{ background: sc.bg, color: sc.cor, padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap' }}>{sc.l}</span>
        </div>
        {l.telefone && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#6B7A8D', marginBottom: '4px' }}>
            📱 {l.telefone}
            <button onClick={e => { e.stopPropagation(); abrirWhatsApp(l.telefone); }}
              style={{ padding: '1px 6px', background: '#25D366', border: 'none', color: '#fff', borderRadius: '4px', cursor: 'pointer', fontSize: '10px', fontWeight: '600' }}>WhatsApp</button>
          </div>
        )}
        {l.interesse && <div style={{ fontSize: '12px', color: '#6B7A8D', marginBottom: '8px' }}>🏍️ {l.interesse}</div>}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px', paddingTop: '8px', borderTop: '0.5px solid rgba(26,58,92,0.08)' }}>
          <div style={{ fontSize: '11px', color: vencido ? '#C0392B' : hoje ? '#E67E22' : '#9AA3AE', fontWeight: vencido || hoje ? '700' : '400' }}>
            {l.proximo_followup ? (vencido ? '⚠ Vencido: ' : hoje ? '⏰ Hoje: ' : '📅 ') + fmt(l.proximo_followup) : 'Sem follow-up'}
          </div>
          <div style={{ fontSize: '10px', color: '#9AA3AE' }}>{l.usuario_nome}</div>
        </div>
      </div>
    );
  };

  const Secao = ({ titulo, cor, lista }) => lista.length === 0 ? null : (
    <div style={{ marginBottom: '28px' }}>
      <div style={{ fontSize: '12px', fontWeight: '700', color: cor, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>{titulo} ({lista.length})</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '12px' }}>
        {lista.map(l => <CardLead key={l.id} l={l} />)}
      </div>
    </div>
  );

  return (
    <div style={{ fontFamily: "'DM Sans',system-ui,sans-serif" }}>
      {alertas.length > 0 && (
        <div style={{ background: '#C0392B', color: '#fff', padding: '10px 18px', borderRadius: '8px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontWeight: '700', fontSize: '13px' }}>⚠ {alertas.length} follow-up(s) vencido(s)!</div>
            <div style={{ fontSize: '12px', opacity: 0.85 }}>{alertas.map(a => a.nome).join(', ')}</div>
          </div>
          <button onClick={tocarAlerta} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' }}>🔔 Som</button>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>CRM — Follow-up</h2>
        <button onClick={() => { setForm({}); setModalLead(true); }}
          style={{ padding: '9px 18px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
          + Novo Lead
        </button>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder='Buscar por nome, telefone ou interesse...'
          style={{ ...inpStyle, width: '320px' }} />
        {[{ v: '', l: 'Todos' }, ...STATUS].map(s => (
          <button key={s.v} onClick={() => setFiltroStatus(s.v)}
            style={{ padding: '7px 14px', background: filtroStatus === s.v ? '#1A3A5C' : '#fff', border: '0.5px solid rgba(26,58,92,0.2)', color: filtroStatus === s.v ? '#fff' : '#6B7A8D', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: filtroStatus === s.v ? '700' : '400', fontFamily: "'DM Sans',system-ui,sans-serif", whiteSpace: 'nowrap' }}>
            {s.l}
          </button>
        ))}
      </div>

      {busca || filtroStatus ? (
        <div>
          {pendentes.length === 0 && <div style={{ ...card, textAlign: 'center', color: '#9AA3AE', padding: '40px' }}>Nenhum lead encontrado</div>}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '12px' }}>
            {pendentes.map(l => <CardLead key={l.id} l={l} />)}
          </div>
        </div>
      ) : (
        <div>
          <Secao titulo="⚡ Ação pendente" cor="#C0392B" lista={pendentes} />
          <Secao titulo="📅 Agendados" cor="#2471A3" lista={agendados} />
          <Secao titulo="✅ Encerrados" cor="#9AA3AE" lista={encerrados} />
          {pendentes.length === 0 && agendados.length === 0 && encerrados.length === 0 && (
            <div style={{ ...card, textAlign: 'center', color: '#9AA3AE', padding: '40px' }}>Nenhum lead cadastrado</div>
          )}
        </div>
      )}

      {/* MODAL NOVO/EDITAR LEAD */}
      {modalLead && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '440px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1C2533' }}>{form.id ? 'Editar Lead' : 'Novo Lead'}</h3>
              <button onClick={() => { setModalLead(false); setForm({}); }} style={{ background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#9AA3AE' }}>×</button>
            </div>
            {[['Nome', 'nome', 'text'], ['Telefone', 'telefone', 'text'], ['Interesse (modelo)', 'interesse', 'text']].map(([l, k, t]) => (
              <div key={k} style={{ marginBottom: '12px' }}>
                <label style={lbl}>{l}</label>
                <input type={t} value={form[k] || ''} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} style={inpStyle} />
              </div>
            ))}
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Status</label>
              <select value={form.status || 'novo'} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} style={inpStyle}>
                {STATUS.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
              </select>
            </div>
            {!form.id && (
              <>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Próximo follow-up</label>
                  <input type='datetime-local' value={form.proximo_followup || ''} onChange={e => setForm(f => ({ ...f, proximo_followup: e.target.value }))} style={inpStyle} />
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Observação inicial</label>
                  <textarea value={form.observacao || ''} onChange={e => setForm(f => ({ ...f, observacao: e.target.value }))}
                    placeholder='Anote informações importantes sobre este lead...'
                    style={{ ...inpStyle, height: '65px', resize: 'vertical' }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => { setModalLead(false); setForm({}); }} style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Cancelar</button>
              <button onClick={salvarLead} disabled={loading} style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>{loading ? 'Salvando...' : 'Salvar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DETALHE */}
      {modalDetalhe && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>{modalDetalhe.nome}</div>
                <div style={{ fontSize: '12px', color: '#6B7A8D' }}>📱 {modalDetalhe.telefone} {modalDetalhe.interesse && `· 🏍️ ${modalDetalhe.interesse}`}</div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button onClick={() => abrirWhatsApp(modalDetalhe.telefone)} style={{ padding: '6px 12px', background: '#25D366', border: 'none', color: '#fff', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>💬 WhatsApp</button>
                <button onClick={() => { setForm(modalDetalhe); setModalDetalhe(null); setModalLead(true); }} style={{ padding: '6px 12px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '7px', cursor: 'pointer', fontSize: '12px' }}>Editar</button>
                <button onClick={() => setModalDetalhe(null)} style={{ background: 'transparent', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9AA3AE' }}>×</button>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '16px' }}>
              {STATUS.map(s => (
                <button key={s.v} onClick={async () => {
                  await api.put('/crm/leads/' + modalDetalhe.id, { ...modalDetalhe, status: s.v });
                  setModalDetalhe(d => ({ ...d, status: s.v }));
                  carregarLeads();
                }} style={{ padding: '4px 10px', background: modalDetalhe.status === s.v ? s.cor : s.bg, color: modalDetalhe.status === s.v ? '#fff' : s.cor, border: `1px solid ${s.cor}`, borderRadius: '20px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}>
                  {s.l}
                </button>
              ))}
            </div>

            {modalDetalhe.proximo_followup && (
              <div style={{ background: isVencido(modalDetalhe.proximo_followup) ? '#FDECEA' : '#FFF3E0', border: `1px solid ${isVencido(modalDetalhe.proximo_followup) ? '#C0392B' : '#E67E22'}`, borderRadius: '7px', padding: '8px 12px', marginBottom: '16px', fontSize: '12px', color: isVencido(modalDetalhe.proximo_followup) ? '#C0392B' : '#B06000', fontWeight: '600' }}>
                {isVencido(modalDetalhe.proximo_followup) ? '⚠ Follow-up vencido: ' : '📅 Próximo follow-up: '}{fmt(modalDetalhe.proximo_followup)}
              </div>
            )}

            <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#9AA3AE', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '8px' }}>Histórico</div>
              {historico.length === 0 && <div style={{ fontSize: '13px', color: '#9AA3AE' }}>Nenhuma interação registrada</div>}
              {historico.map(h => (
                <div key={h.id} style={{ borderLeft: '2px solid #E8ECF0', paddingLeft: '12px', marginBottom: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9AA3AE', marginBottom: '2px' }}>
                    <span style={{ fontWeight: '600', color: '#1A3A5C' }}>{h.usuario_nome}</span>
                    <span>{fmt(h.created_at)}</span>
                  </div>
                  <div style={{ fontSize: '13px', color: '#1C2533' }}>{h.descricao}</div>
                  {h.proximo_followup && (
                    <div style={{ fontSize: '11px', color: '#E67E22', fontWeight: '600', marginTop: '3px' }}>📅 Agendado: {fmt(h.proximo_followup)}</div>
                  )}
                </div>
              ))}
            </div>

            <div style={{ borderTop: '0.5px solid rgba(26,58,92,0.1)', paddingTop: '16px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#9AA3AE', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '10px' }}>Registrar interação</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '8px' }}>
                <div>
                  <label style={lbl}>Tipo</label>
                  <select value={formHist.tipo} onChange={e => setFormHist(f => ({ ...f, tipo: e.target.value }))} style={inpStyle}>
                    <option value='observacao'>Observação</option>
                    <option value='ligacao'>Ligação</option>
                    <option value='whatsapp'>WhatsApp</option>
                    <option value='visita'>Visita</option>
                    <option value='proposta'>Proposta enviada</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Próximo follow-up</label>
                  <input type='datetime-local' value={formHist.proximo_followup} onChange={e => setFormHist(f => ({ ...f, proximo_followup: e.target.value }))} style={inpStyle} />
                </div>
              </div>
              {formHist.proximo_followup && (
                <div style={{ background: '#FFF3E0', border: '1px solid #E67E22', borderRadius: '6px', padding: '6px 10px', marginBottom: '8px', fontSize: '12px', color: '#B06000', fontWeight: '600' }}>
                  📅 Agendando follow-up para: {new Date(formHist.proximo_followup).toLocaleString('pt-BR', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}
                </div>
              )}
              <div style={{ marginBottom: '8px' }}>
                <label style={lbl}>Alterar status</label>
                <select value={formHist.status || ''} onChange={e => setFormHist(f => ({ ...f, status: e.target.value }))} style={inpStyle}>
                  <option value=''>Manter status atual</option>
                  {STATUS.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
                </select>
              </div>
              <textarea value={formHist.descricao} onChange={e => setFormHist(f => ({ ...f, descricao: e.target.value }))}
                placeholder='Descreva o contato realizado...'
                style={{ ...inpStyle, height: '70px', resize: 'vertical', marginBottom: '8px' }} />
              <button onClick={salvarHistorico}
                style={{ width: '100%', padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Registrar interação
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.7} }`}</style>
    </div>
  );
}
